import apiClient from '@/utils/api-client'

class PaypalService {
    public getPaymentUrl(planId: string) {
        return new Promise<string>((resolve, reject) => {
            apiClient.get('/api/v1/paypal/payment-url/' + planId).then((res) => {
                if (res.status == 200 && res.data != null) {
                    if (res.data.status == 6012) {
                        resolve(res.data.url)
                    } else {
                        resolve("false")
                    }
                } else {
                    resolve("false")
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
    public getPaymentUrlV2(planId: string) {
        return new Promise<string>((resolve, reject) => {
            apiClient.get('/api/v1/paypal/payment-url-v2/' + planId).then((res) => {
                if (res.status == 200 && res.data != null) {
                    if (res.data.status == 6012) {
                        resolve(res.data.url)
                    } else {
                        resolve("false")
                    }
                } else {
                    resolve("false")
                }
            }).catch((error) => {
                reject(error)
            })
        })
    }
    public captureOrder(orderId: string) {
        return new Promise<boolean>((resolve, reject) => {
            apiClient.get(`/api/v1/paypal/capture-order?orderId=${orderId}`).then((res) => {
                if (res.status === 200 && res.data) {
                    if (res.data.code == 0) {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                } else {
                    resolve(false)
                }
            }).catch((error) => {
                //console.error('PayPal capture error:', error)
                resolve(false)
            })
        })
    }
}

export default new PaypalService()
